import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DisableDirective } from '../appDisable.directive';
import { GreyedOutDirective } from '../greyedout.directive';




@NgModule({
  declarations: [DisableDirective,GreyedOutDirective],
  imports: [
    CommonModule,    
  ],
  exports:[DisableDirective,GreyedOutDirective]
})
export class DirectiveModuleModule { }
